export default "__VITE_ASSET__CFGw$HYK__"